<template>
  <div id="app" :class="drawerStatus == false ? '' : 'small'">
    <b-overlay
      style="z-index: 99999999 !important"
      variant="dark"
      no-wrap
      :show="overlay"
      opacity="0.7"
    >
      <template v-slot:overlay>
        <b-card class="text-center" style="width: 300px">
          <b-card-text class="text-center">
            <div class="mb-4">
              <b-spinner
                style="width: 4.5rem; height: 4.5rem"
                variant="primary"
                label="chargement..."
              ></b-spinner>
            </div>
            <div class="text-center">
              <span style="font-size: 1.5rem">Chargement...</span>
            </div>
          </b-card-text>
        </b-card>
      </template>
    </b-overlay>

    <div v-if="latests != null && latests.length > 0" class="top-alert">
      <b-alert
        v-for="latest in latests"
        :key="latest.id"
        dismissible
        :variant="latest.type"
        show
      >
        <span class="message">{{ latest.message }}</span>
      </b-alert>
    </div>
    <sidebar
      v-if="
        $route.name != 'Login' &&
        $route.name != 'Cerfa' &&
        $route.name != 'Password' &&
        $route.name != 'ForgotPassword'
      "
    ></sidebar>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import SideBar from "./views/Sidebar.vue";
import Vuex from "vuex";
import Vue from "vue";

export default {
  name: "App",
  data: () => ({
    overlay: false,
  }),
  methods: {
    showSpinner() {
      this.overlay = true;
    },
    hideSpinner() {
      this.overlay = false;
    },
    ...Vuex.mapActions("Authentification", ["setDrawer", "getUserConnected"]),
    ...Vuex.mapActions("BroadCastMessage", ["getLatestMessage"]),
  },
  computed: {
    ...Vuex.mapGetters("BroadCastMessage", ["latests"]),
    ...Vuex.mapGetters("Authentification", ["drawerStatus"]),
  },
  created() {
    this.$aes.setKey(
      "@UpCm5quJ0bO9osH28Gd5myA5q!qfz@OV8o0Be!C%gn$Mf3dU6UKL7kWJdfAxO#n!KAwusvHz5YJ5DqatLPCVx6VjGnyjUVPdTP"
    );
    window.Event.$on("before-request", this.showSpinner);
    window.Event.$on("request-error", this.hideSpinner);
    window.Event.$on("after-response", this.hideSpinner);
    window.Event.$on("response-error", this.hideSpinner);
  },
  mounted() {
    this.getLatestMessage();
  },
  beforeDestroy() {
    window.Event.$off("before-request", this.showSpinner);
    window.Event.$off("request-error", this.hideSpinner);
    window.Event.$off("after-response", this.hideSpinner);
    window.Event.$off("response-error", this.hideSpinner);
  },
  components: {
    sidebar: SideBar,
  },
};
</script>

<style lang="scss">
@import "./styles/index.scss";
</style>
